import React from 'react';
import Skeleton from 'ati-ui-react/components/Skeleton';
import * as styles from './BreadcrumbsRowLoading.scss';

const BreadcrumbsRowLoading = () => (
  <div className={styles.breadcrumbs}>
    <div className={styles.linksContainer}>
      <Skeleton />
    </div>
    <div className={styles.faqContainer}>
      <Skeleton />
    </div>
  </div>
);

export default BreadcrumbsRowLoading;
